import React from 'react'
import PropTypes from 'prop-types'
import {
  Nav,
  NavLink,
  NavItem,
} from 'reactstrap'
import branding from 'shared/branding'
import {
  CSH
} from 'constants/values'

const SelectionTabs = ({
  activeTab,
  setActiveTab,
  tabList
}) => {
  const brand = branding.current.key
  const activeTabClass = `selection-tab-active bg-primary ${brand === CSH ? '' : 'text-white'}`
  return (
    <Nav
      tabs
      className="selection-tabs-nav border-primary border-bottom-0 d-flex justify-content-between justify-content-md-start w-100"
    >
      {tabList.map((tab, index) => (<NavItem key={tab.productCode || index} className={`p-0 ${index > 0 ? 'ml-md-2' : ''}`}>
        <NavLink
          active={activeTab === index}
          className={`selection-tab ${activeTab === index ? activeTabClass : 'selection-tab-inactive text-body'}`}
          onClick={() => setActiveTab(index)}
        >
          <strong className="tabTitle">{tab.title}</strong>
          {tab.subTitle}
        </NavLink>
      </NavItem>))}
    </Nav>
  )
}

SelectionTabs.propTypes = {
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      productCode: PropTypes.string,
      title: PropTypes.node.isRequired,
      subTitle: PropTypes.node,
    })
  ).isRequired,
}

export default SelectionTabs
